import type { ComponentProps, ReactNode } from "react";
import { HStack, SimpleGrid, Text } from "@chakra-ui/react";
import { usePortalPath } from "hooks/use-portal-path";

type SimpleGridTableProps = {
  items: { label: string; value: ReactNode }[];
  simpleGridProps?: ComponentProps<typeof SimpleGrid>;
};
export function SimpleGridTable({
  items,
  simpleGridProps,
}: SimpleGridTableProps) {
  const { isTenantPath } = usePortalPath();

  return (
    <SimpleGrid
      columns={[1, 2]}
      {...(!isTenantPath && { spacing: 4 })}
      {...simpleGridProps}
    >
      {items.map((item) => (
        <HStack
          key={item.label}
          w={"100%"}
          borderBottom={"1px solid"}
          borderColor={"gray.200"}
          justifyContent={"space-between"}
          fontSize={"lg"}
          lineHeight={6}
          px={6}
          py={isTenantPath ? 3 : 2}
        >
          <Text
            fontWeight={500}
            {...(isTenantPath && { fontSize: { base: "md", lg: "lg" } })}
          >
            {item.label}
          </Text>
          <Text
            fontWeight={400}
            textAlign={"end"}
            {...(isTenantPath && { fontSize: { base: "md", lg: "lg" } })}
          >
            {item.value}
          </Text>
        </HStack>
      ))}
    </SimpleGrid>
  );
}
